import React, { useState } from "react"
import { HashRouter, Link } from "react-router-dom"
import { setCurrentSong, setGoToCurrentPlayList } from "../../../action/musicAction"
import { connect } from "react-redux"
import { currentWidget } from "../../../action/action"
import { CMSPath } from "../../../config/constant"

const CurrentPlayingSong = (props) => {


    const audioRef = React.createRef()
    const prevSongRef = React.useRef();

    const base_url = `${CMSPath}/cmsData/musicApp/songs/`
    const [musicState, setMusicState] = useState({
        currentTime: 0,
        duration: 180,
    })

    const handleOpenSong = () => {
        props.setGoToCurrentPlayList(true);
    }

    // Set up the song to replay if Repeat One is active
    const handleSongEnd = () => {
        const { shuffle, repeatOne } = props.musicConfig
        const { musicList, currentSong } = props;

        const currentIndex = musicList.findIndex((song) => song.id === (currentSong && currentSong.id));

        if (repeatOne) {
            // Repeat One: restart the current song
            audioRef.current.load();
            audioRef.current.currentTime = 0;  // Reset the audio to start
            audioRef.current.play();           // Start playing from the beginning
        } else if (shuffle) {
            // Shuffle mode: play a random song
            let randomIndex;
            do {
                randomIndex = Math.floor(Math.random() * musicList.length);
            } while (randomIndex === currentIndex);

            props.setCurrentSong({ ...musicList[randomIndex], playSong: true });
        } else {
            // Default mode: play the next song in the list
            const nextIndex = (currentIndex + 1) % musicList.length;
            props.setCurrentSong({ ...musicList[nextIndex], playSong: true });
        }
    };

    const setPlay = () => {
        const { currentSong } = props;

        props.setCurrentSong({ ...currentSong, playSong: !currentSong.playSong });
    };

    const updateTime = (event) => {
        setMusicState((prevState) => ({
            ...prevState,
            currentTime: event.target.currentTime,
        }));
    };

    const updateDuration = (event) => {
        setMusicState((prevState) => ({
            ...prevState,
            duration: event.target.duration,
        }));
    };

    const handleTimelineChange = (event) => {
        const newTime = (event.target.value / 100) * musicState.duration;
        if (audioRef.current) {
            audioRef.current.currentTime = newTime;
        }
        setMusicState((prevState) => ({
            ...prevState,
            currentTime: newTime,
        }));
    };

    React.useEffect(() => {


        const prevSong = prevSongRef.current;

        // If the song ID has not changed, pause the current song and return early
        if (prevSong && prevSong.id == props.currentSong.id && prevSong.playSong != props.currentSong.playSong) {
            if(props.currentSong.playSong) {
                audioRef.current && audioRef.current.play();
            } else {
                audioRef.current && audioRef.current.pause();
            }
            return;
        }

        setMusicState({
            currentTime: 0,
            duration: 180,
        })

        prevSongRef.current = props.currentSong;

        if (audioRef.current) {
            audioRef.current.load();
            audioRef.current.currentTime = 0;  // Reset the audio to start
            audioRef.current.play();
        }

    }, [props.currentSong])

    return (
        <div>
            {props.isPlayInBackground &&
                <HashRouter>
                    <Link exact to="/music" class="music-overlay" onClick={handleOpenSong}>
                        <div class="music-title">
                            <span class="song-name">{props.currentSong ? props.currentSong.title : "Title"}
                            </span> - <span class="artist-name">{props.currentSong ? props.currentSong.artist : "Artist Name"}</span>
                        </div>
                    </Link>
                </HashRouter>
            }


            {/* 
                <div className="music-controls">
                    <div className="timeline">
                        <div className="time-stamp">
                            <div className="time-start">{Math.floor(musicState.currentTime / 60)}:{("0" + Math.floor(musicState.currentTime % 60)).slice(-2)}</div>
                            <div className="time-end">
                                {Math.floor(musicState.duration / 60)}:{("0" + Math.floor(musicState.duration % 60)).slice(-2)}
                            </div>
                        </div>
                        <div className="timeline">
                            <input type="range" min="0" max="100" value={(musicState.currentTime / musicState.duration) * 100 || 0}
                                onChange={handleTimelineChange}
                                className="music-timeline" id="musicRange" />
                        </div>
                    </div>
                </div>
            */}

            <audio
                ref={audioRef}
                onTimeUpdate={updateTime} // update time as audio plays
                onLoadedMetadata={updateDuration}
                onEnded={handleSongEnd}  // Replays if Repeat One is active
            >
                <source src={encodeURI(`${base_url}${props.currentSong.songFileName}`)} type="audio/mpeg" />
            </audio>
        </div>
    )
}


const mapStateToProps = state => {
    return {
        musicList: state.store.music.musicList,
        isPlayInBackground: state.store.music.isPlayingInBackground,
        currentSong: state.store.music.currentSong,
        musicConfig: state.store.music.musicConfig,
        songBaseUrl: state.store.music.musicGenres.songBaseUrl
    }
}

export default connect(
    mapStateToProps,
    {
        setCurrentSong,
        currentWidget,
        setGoToCurrentPlayList
    }
)(CurrentPlayingSong);